export default __webpack_public_path__ + "static/unimed-e35d5fe8d927dab7d0f77f1719a9cd0c.png";